import { AccountPage } from "@common-components/account-page/account-page";
import BTThemeProvider from "@common-components/bt-theme-provider";
import { SideBarItem } from "@common-components/sidebar/sidebar";

import { useEffect } from "react";

import WorkspaceUsersMembers from "@common-components/account-users-table/workspace-users-members";
import { namespace } from "@common-config/constants";
import { useTranslation } from "react-i18next";
import { UserManagementHeader } from "./user-management-header";
import classes from "../account-view/account-view.module.scss";

export interface UserManagementViewProps {
  readOnly?: boolean;
}
export default function UserManagementView({readOnly}:UserManagementViewProps) {
  const { t } = useTranslation(namespace);  
  useEffect(() => {
    document.title = t('userManagementView.title');
  }, []);

  const userManagement = () => {
    return (
      <>
      <div className={classes.pageContainer}>
        <div className={classes.titleContainer}>
          <h4 className={classes.pageTitle}>{t('userManagementView.members')}</h4>
        </div>

        <div className={classes.accountSettingBody}>
          <UserManagementHeader readOnly={readOnly} />
          <WorkspaceUsersMembers readOnly={readOnly} />
        </div>
      </div>
    
      </ >
    );
  };


  return (
    <BTThemeProvider>
      <AccountPage
        page={userManagement()}
        readOnly={readOnly}
      ></AccountPage>
    </BTThemeProvider>
  );
};
